module.exports = __webpack_public_path__ + "static/media/my_book_register.ad773c79.PNG";